<template>
    <div>
        <draggable class="list" v-model="setTingObj.menuConfig.list" :animation="150">
            <div class="item" v-for='(item,index) in setTingObj.menuConfig.list' :key="index">
                <div class='item-left'>
                    <div class='delete-btn' @click='deleteItem(index)'>
                        <i class='el-icon-error'></i>
                    </div>
                    <div class='flag'>
                        <i class='el-icon-more'></i>
                    </div>
                    <uploadImage :imageUrl="item.img" @deleteUrl="deleteLogoUrl(index)" @updateUrl="updateLogoUrl($event,item)"/>
                </div>
                <div class='item-right'>
                    <el-input v-model='item.info[0].value' :max='item.info[0].max' placeholder="请输入标题" size='small'></el-input>
<!--                    <el-input v-model='item.info[1].value' :max='item.info[1].max' placeholder="请输入链接" size='small'></el-input>-->
                    <pathselect :value="item.info[1].value" :disabled="false"  @change="changePathSelect($event,item.info[1])"></pathselect>
                </div>
            </div>
        </draggable>
        <div class='add-btn' @click='addItem'>
            <span>添加</span>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import uploadImage from '@/components/decoration/common/uploadImage.vue';
import Pathselect from '@/components/pathselect/pathselect.vue';
export default {
    components:{
        draggable,
        uploadImage,
        Pathselect
    },
    props:{
        setTingObj:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {};
    },
    methods: {
        deleteItem(index){
            this.setTingObj.menuConfig.list.splice(index,1)
        },
        addItem(){
            this.setTingObj.menuConfig.list.push({
                img:'',
                info:[
                    {
                        value:'',
                        max: 4
                    },
                    {
                        value:'',
                        max: 100
                    }
                ]
            })
        },
        deleteLogoUrl(index){
            this.setTingObj.menuConfig.list.splice(index,1)
        },
        updateLogoUrl(url,item){
            item.img = url
        },
        changePathSelect(e,obj){
            obj.value = e;
        }
    }
};
</script>

<style lang='scss' scoped>
.item{
    width: 100%;
    height: 80px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: row;
    .item-left{
        position: relative;
        width: 110px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .delete-btn{
            position: absolute;
            top: -15px;
            right: 1px;
            font-size: 24px;
            z-index: 1;
        }
        .flag{
            width: 30px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            >i{
                transform: rotate(90deg);
                color: #dddddd;
                cursor: move;
            }
        }
    }
    .item-right{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        ::v-deep .el-input {
            width: 240px;
        }
    }
}

.add-btn{
    width: 100%;
    height: 40px;
    margin-top: 20px;
    background-color: #409EFF;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
</style>